module.exports = __webpack_public_path__ + "static/img/40015 (1).26f6d8c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40015 (1).webp
// module id = 95gX
// module chunks = 14